var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoToggleOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    rx: 10,
    fill: "#1648D2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(12)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 1.66669C17.4 1.66669 13.6667 5.40002 13.6667 10C13.6667 14.6 17.4 18.3334 22 18.3334C26.6 18.3334 30.3333 14.6 30.3333 10C30.3333 5.40002 26.6 1.66669 22 1.66669ZM19.7417 13.575L16.75 10.5834C16.425 10.2584 16.425 9.73335 16.75 9.40835C17.075 9.08335 17.6 9.08335 17.925 9.40835L20.3333 11.8084L26.0667 6.07502C26.3917 5.75002 26.9167 5.75002 27.2417 6.07502C27.5667 6.40002 27.5667 6.92502 27.2417 7.25002L20.9167 13.575C20.6 13.9 20.0667 13.9 19.7417 13.575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoToggleOn);
export default __webpack_public_path__ + "static/media/ico-toggle-on.cf7f0d953c4f33aec41ee616aab40481.svg";
export { ForwardRef as ReactComponent };